import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';
import React from 'react';

export const BrandIconFreeDelivery = () => {
  return (
    <Svg width="49" height="13" viewBox="0 0 49 13" fill="none">
      <G clipPath="url(#clip0_3531_109318)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.5139 4.2251H42.4551L41.8921 6.06676H43.9508L44.5139 4.2251Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.0076 0.216553H33.3775L29.4692 12.9999H31.0993L35.0076 0.216553Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.7161 0.216553H36.086L32.1777 12.9999H33.8078L37.7161 0.216553Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6538 10.0749H29.2885L32.17 0.649902H30.5353L27.6538 10.0749Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0786 10.0749H25.7133L28.5948 0.649902H26.9601L24.0786 10.0749Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.1811 3.46655H26.5268L26.0654 5.09155H30.7198L31.1811 3.46655Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.6668 8.44995H25.0124L24.5156 10.075H29.17L29.6668 8.44995Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.8504 5.7417H32.0627L31.5659 7.3667H35.3536L35.8504 5.7417Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.6115 6.28345H14.8347L14.3379 7.90845H23.1147L23.6115 6.28345Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6958 11.3751H16.3215L17.5139 7.4751H15.8882L14.6958 11.3751Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3794 11.3751H20.0051L21.1975 7.4751H19.5717L18.3794 11.3751Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.9504 0.216553H43.4945L38.2012 4.65822H40.657L45.9504 0.216553Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.3259 4.65827H48.4854L46.5222 1.5166H44.3628L46.3259 4.65827Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.6058 5.7417H37.4485L36.9517 7.3667H48.109L48.6058 5.7417Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3194 10.075H12.1682L11.6714 11.7H22.8226L23.3194 10.075Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2453 7.3667H1.08519L0.588379 8.9917H11.7485L12.2453 7.3667Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.5865 0.649902H15.9119L15.415 2.2749H24.0897L24.5865 0.649902Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.046 3.46655H15.3713L14.8745 5.09155H23.5492L24.046 3.46655Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3196 0.649902H4.22679L3.72998 2.2749H12.8228L13.3196 0.649902Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0197 4.65845H2.81859L2.32178 6.28345H11.5229L12.0197 4.65845Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0732 6.28324H11.699L13.4213 0.649902H11.7955L10.0732 6.28324Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.27344 6.28324H3.89917L5.62145 0.649902H3.99572L2.27344 6.28324Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.0127 13.0001H5.87301L7.42969 7.90845H5.56937L4.0127 13.0001Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6968 7.90822H15.3225L16.6804 3.46655H15.0547L13.6968 7.90822Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9209 5.09157H23.5466L24.9046 0.649902H23.2789L21.9209 5.09157Z"
          fill="#FE9D1E"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.4004 8.44995C38.2573 8.44995 37.2483 9.1966 36.914 10.2898L36.5991 11.3199C36.3437 12.1554 36.9686 13 37.8423 13H43.5946C44.7378 13 45.7468 12.2533 46.081 11.1601L46.3959 10.13C46.6514 9.29454 46.0264 8.44995 45.1527 8.44995H39.4004ZM44.5858 10.355C44.6283 10.2157 44.5242 10.075 44.3786 10.075H39.3624C38.9814 10.075 38.645 10.3238 38.5336 10.6882L38.4093 11.0949C38.3667 11.2342 38.4709 11.375 38.6165 11.375H43.6326C44.0137 11.375 44.35 11.1261 44.4614 10.7617L44.5858 10.355Z"
          fill="#FE9D1E"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3531_109318">
          <Rect
            width="48.75"
            height="13"
            fill="white"
            transform="translate(0.125)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
